import { NoCoverSection } from './view';
export default NoCoverSection;
